import"./SubCategories.css.ts.vanilla.css";var e="jeulny1",r="jeulny0";export{e as categoryList,r as subCategoriesContainer};
